module.exports = __webpack_public_path__ + "static/media/samanthaRizzo.6abd1dd7.jpg";